<p *ngIf="!hideLabel" class="mb-1">{{ label }}</p>

<div class="editor-container-wrapper" [class.with-ai-bar]="showAiSuggestions">
	<!-- AI Suggestion Bar -->
	<app-ai-code-suggestions
		*ngIf="showAiSuggestions && !isLoading"
		[code]="editor?.getValue() || currentValue"
		[language]="language"
		[customPrompt]="aiCustomPrompt"
		(codeApplied)="onAiCodeApplied($event)"
		(codeReverted)="onAiCodeReverted($event)">
	</app-ai-code-suggestions>

	<div class="editor-wrapper"
		[class.wrong-input]="incorrectInput"
		[formGroup]="form">
		<!-- Fullscreen button positioned in top-right of editor -->
		<a
			class="ribbon-button fullscreen-button"
			(click)="openFullscreenEditor()"
			matTooltip="Open in fullscreen"
			matTooltipPosition="left"
			*ngIf="!isLoading">
			<mat-icon inline>open_in_full</mat-icon>
		</a>

		<!-- Preloader overlay -->
		<div *ngIf="isLoading" class="monaco-preloader">
			<span class="gtb-loader small"></span>
			<p class="loading-text">Loading editor...</p>
		</div>

		<ngx-monaco-editor
			[options]="editorOptions"
			[formControlName]="controlName"
			(onInit)="onEditorInit($event)"
		></ngx-monaco-editor>
	</div>
</div>

<div class="mb-2" *ngIf="showValidationError && incorrectInput">
	<span class="text-danger">
		<ng-container i18n="Invalid JSON@@monacoInputInvalidJsonWarning">Invalid JSON</ng-container>
	</span>
</div>

<div class="mb-2" (click)="formatAndValidate()" *ngIf="showFormatButton">
	<button mat-flat-button
			color="primary"
			matTooltip="Format"
			i18n-matTooltip="Format Button@@monacoInputFormatButton"
	>
		<mat-icon>brush</mat-icon>
	</button>
</div>

<div *ngIf="hint" class="input-hint">{{ hint }}</div>
